import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/our-work/design1studio/page.tsx");
